import React from 'react';
import ReactPlayer from 'react-player';
import './FullScreenPlayer.css';

const FullScreenPlayer = ({ url }) => {
  return (
    <div className="player-wrapper">
      <ReactPlayer
        className="react-player"
        url={url}
        width="100%"
        height="100%"
        controls={true}
        playing={true}
      />
    </div>
  );
};

export default FullScreenPlayer;
